var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('btn',{attrs:{"click":_vm.addFile,"icon":"fas fa-plus"}},[_vm._v("Add File")]),_vm._v(" "),_c('input',{ref:"files",staticStyle:{"visibility":"hidden"},attrs:{"type":"file","id":"files","multiple":""},on:{"change":function($event){return _vm.handleFileUpload()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }